const styles = theme => ({
  dummyHeader: {
    background: "#000000",
    height: "60px"
  },

  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "100vh",
    flexDirection: "column",
    fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
    fontSize: "14px"
  },
  container: {
    maxWidth: "1215px",
    margin: "auto",
    position: "relative",
    [theme.breakpoints.down("lg")]: {
      width: "calc(100% - 30px)"
    }
  },
  largeButton: {
    color: "#fff",
    padding: "7px 25px",
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      top: "23px",
      right: "0",
      padding: "7px 6px",
      minWidth: "98px"
    }
  },
  headingWrap: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "30px",
    paddingBottom: "20px",
    [theme.breakpoints.down("xs")]: {
      display: "inherit",
      position: "relative",
      paddingTop: "0"
    }
  },
  headingButtonWrap: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      display: "inherit"
    }
  },
  searchInput: {
    background: "#fff",
    minWidth: "187px",
    height: "40px",
    padding: "0 5px 0 10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "4px",
    border: "solid 1px #eeeeee",
    boxShadow: "none",
    "& input": {
      padding: "0 8px",
      fontSize: "13px",
      fontFamily: "titilliumlight, Helvetica Neue, sans-serif"
    },

    "& button": {
      padding: "5px"
    },

    "& svg": {
      fill: "#adadad",
      fontSize: "20px"
    }
  },
  headingWrapheading: {
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    color: "#323233",
    fontSize: "22px",
    display: "flex",
    alignItems: "center",
    margin: "25px 0",
    [theme.breakpoints.down("xs")]: {
      fontSize: "20px"
    },
    "& a": {
      marginRight: "20px",
      "& img": {
        display: "block"
      }
    }
  },
  searchData: {
    width: "204px",
    padding: "13px 20px",
    border: "1px solid #eeeeee",
    borderRadius: "4px"
  },
  innerWrap: {
    minHeight: "calc(100vh - 100px)",
    margin: "0 80px",
    [theme.breakpoints.down("sm")]: {
      margin: "0"
    }
  },
  dashboardTable: {
    overflow: "auto",
    paddingBottom: "15px",
    "& table": {
      [theme.breakpoints.down("sm")]: {
        whiteSpace: "nowrap"
      }
    },

    "& th": {
      fontSize: "14px",
      color: "#323233",
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      border: "none",
      padding: "12px 20px 23px 20px"
    },
    "& thead": {
      background: "#fff",
      whiteSpace: "nowrap"
    },

    "& tbody": {
      background: "#fff"
    },
    "& td": {
      fontSize: "14px",
      color: "#96989b",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
      border: "none",
      padding: "12px 20px",
      position: "relative"
    }
  },
  showingTile: {
    "& a": {
      fontSize: "14px",
      color: "#ea4367",
      textDecoration: "none",
      width: "38px",
      height: "22px",
      background: "rgba(234, 67, 103, 0.1)",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "2px",
      boxShadow: "0 2px 3px 0 rgba(220, 220, 220, 0.5)"
    }
  },
  actionTile: {
    "& a": {
      textDecoration: "none",
      marginRight: "3px"
    }
  },

  paginationSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
    "& div:first-child": {
      background: "#fff",
      border: "solid 1px #f4f4f4",
      borderRadius: "25px",
      boxShadow: "0 2px 14px 0 rgba(225, 225, 225, 0.5)",
      height: "auto",
      minHeight: "auto"
    }
  },

  copyright: {
    fontSize: "13px",
    color: "#58637d",
    fontFamily: "montserratregular, Helvetica Neue, sans-serif",
    padding: "10px",
    textAlign: "center",
    "& span": {
      color: "#ff3f79"
    }
  },
  //add retailor pop up
  popup: {
    "& button": {
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      marginLeft: "20px",
      marginBottom: "20px",
      [theme.breakpoints.down("xs")]: {
        width: "calc(100% - 40px)"
      }
    },
    "& asd": {
      width: "500px"
    },

    "& sdx": {
      width: "500px"
    }
  },
  popupTitle: {
    "& h6": {
      fontSize: "22px",
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      color: "#323233",
      paddingBottom: "8px",
      borderBottom: "1px solid #d8d8d8",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    "& span": {
      color: "#ff3f79"
    }
  },

  popupBuyerTitle: {
    "& h6": {
      fontSize: "26px",
      paddingBottom: "15px"
    }
  },

  gridRow: {
    width: "calc(510px - 48px)",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },
    "& div": {
      marginBottom: "5px",
      [theme.breakpoints.down("xs")]: {
        paddingRight: "0"
      }
    }
  },

  fieldGridLeft: {
    paddingRight: "30px",
    [theme.breakpoints.down("xs")]: {
      paddingRight: "0"
    }
  },
  fieldGridRight: {
    paddingLeft: "30px",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "0"
    }
  },

  buyerDetailBtn: {
    fontSize: "12px",
    fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
    color: "#279110",
    textDecoration: "none",
    padding: "4px 15px",
    background: "rgba(69, 214, 38, 0.1)",
    border: "none",
    cursor: "pointer",
    "&:focus": {
      outline: "none"
    }
  },

  buyerPopupDetails: {
    width: "calc(511px - 24px)",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },

    "& div": {
      [theme.breakpoints.down("xs")]: {
        width: "100%"
      }
    },
    "& h3": {
      fontSize: "14px",
      color: "#323233",
      textTransform: "uppercase",
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      margin: "10px 0 20px 0"
    }
  },

  Infocard: {
    background: "none",
    boxShadow: "none",
    marginBottom: "20px",
    width: "100%",
    "& h6": {
      fontSize: "12px",
      color: "#232323",
      margin: "0",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif"
    },
    "& h5": {
      fontSize: "16px",
      color: "#585858",
      margin: "0",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif"
    },

    "& h4": {
      fontSize: "13px",
      color: "#323233",
      margin: "0",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
      marginTop: "2px",
      textAlign: "center"
    },

    "& img": {
      maxWidth: "100%"
    }
  },
  pageLoader: {
    height: "calc(100vh - 60px)",
    width: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  noResultFound: {
    textAlign: "center",
    fontSize: "20px",
    fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
    color: "#ea4367",
    margin: "20px 0"
  }
});
export default styles;
